export default __webpack_public_path__ + "static/media/BlueHeart.704d9c99.svg";